function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 
 * @file Helper for the Box Item (File/Folder) Collaborations API
 * @author Box
 */
import MarkerBasedAPI from './MarkerBasedAPI';
import { DEFAULT_MAX_COLLABORATORS } from '../constants';

class ItemCollaborations extends MarkerBasedAPI {
  constructor() {
    var _this;

    super(...arguments);
    _this = this;

    _defineProperty(this, "getCollaborations", function (id, successCallback, errorCallback) {
      let requestData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      let limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : DEFAULT_MAX_COLLABORATORS;

      _this.markerGet({
        id,
        limit,
        successCallback,
        errorCallback,
        requestData
      });
    });

    _defineProperty(this, "successHandler", data => {
      if (this.isDestroyed() || typeof this.successCallback !== 'function') {
        return;
      }

      this.successCallback(data); // defined in this.markerGet()
    });
  }

  /**
   * API URL for collaborations
   *
   * @param {string} id - Item ID
   * @protected
   * @return {string} Base URL for collaborations
   */
  getUrl(id) {
    return "getUrl(".concat(id, ") should be overridden");
  }
  /**
   * API for fetching collaborations on a Box item
   *
   * @param {string} id - Item ID
   * @param {Function} successCallback - Success callback
   * @param {Function} errorCallback - Error callback
   * @param {Object} [requestData] - Optional additional request data
   * @param {number} [limit] - Max number of collaborations to return
   * @returns {void}
   */


}

export default ItemCollaborations;
//# sourceMappingURL=ItemCollaborations.js.map